import { useEffect, useState } from "react";
import './FamilySwicth.css';
import t from './translations/translate.ts';
import checked from './images/checkbox/checkbox_uncheck.svg';
import { useLocale } from './LocaleContext';

export default function LangNewSwitch({ isOpen = true, close = () => null }) {
    const { locale: currentLocale, setLocale } = useLocale();
    
    if (!isOpen) {
        return <div style={{ width: 0, height: 0, display: 'none' }} />
    }
    //
    const [isClosing, setIsClosing] = useState(false);
    const [isStarting, setIsStarting] = useState(true);
    const [isPreloading, setIsPreloading] = useState(true);
    //
    const LangLIst = [
        { "label": 'עברית', "code": 'iw' },
        { "label": 'English', "code": 'en' },
        { "label": 'العربية', "code": 'ar' },
        { "label": 'Deutsch', "code": 'de' },
        { "label": 'Русский', "code": 'ru' },
    ];
    //
    const defaultHeight = Math.min((99 + (LangLIst.length * 50)), (document.body.offsetHeight * 0.75));
    const preloadHeight = defaultHeight + 8;
    //
    useEffect(() => {
        if (isStarting) {
            setIsStarting(false);
            setTimeout(() => setIsPreloading(false), 550);
        }
    }, [isStarting]);
    //
    return <div
        style={{
            userSelect: 'none',
            msUserSelect: 'none',
            MozUserSelect: 'none',
        }}>
        <div
            className={isClosing || isStarting ? "hideSwicthBackground" : "showSwicthBackground"}
            onClick={() => {
                setIsClosing(true);
                setTimeout(close, 600);
            }} style={{
                width: '100%', height: '100vh', //backgroundColor: '#00000066',
                bottom: 0, left: 0, right: 0, zIndex: 200, position: 'fixed'
            }} />

        <div

            className={(isClosing || isStarting ? "hideSwitch" : isPreloading ? "showSwitchPreload" : "showSwitch")}
            style={{
                backgroundColor: '#FAF7F2', padding: 0, width: '100%',
                height: isPreloading ? preloadHeight : defaultHeight,
                overflowY: 'scroll', overflowX: 'hidden',
                bottom: 0, left: 0, right: 0, zIndex: 500, position: 'fixed',
                borderTopLeftRadius: 24, borderTopRightRadius: 24
            }}>
            <div style={{ paddingTop: 16, paddingBottom: 0 }}>
                <div style={{
                    width: 60, height: 4, margin: 'auto',
                    backgroundColor: '#D9D9D9', borderRadius: 40
                }} />
            </div>

            <div style={{ padding: 16, paddingTop: 5 }}>
                <p className='SwitchTitle _black_bold'>
                    {t('langSwitchHeader')}
                    <br />
                    <span className='SwitchSubtitle _grey_14' style={{ lineHeight: '25px' }}>
                        {t('langSwitchSubtitle')}
                    </span>
                </p>

                <table style={{
                    width: '100%',
                    padding: 16,
                    backgroundColor: '#FFF',
                    borderRadius: 24
                }}>
                    <tbody>
                        {LangLIst.map((row, index) => <>

                            <tr>
                                <td className="_black">
                                    <div
                                        style={{ lineHeight: '28px' }}
                                        onClick={() => {
                                            setLocale(row.code);
                                        }}
                                        className='LangSwitchRow'
                                    >
                                        {row.label}
                                    </div>
                                </td>
                                <td style={{ width: 25 }}>
                                    {currentLocale == row.code ?
                                        <img
                                            src={checked}
                                            alt='selected' />
                                        : <></>}
                                </td>
                            </tr>
                            {index < 4 ? <tr>
                                <td colSpan={2}>
                                    <div style={{ width: '100%', backgroundColor: '#F0F0F0', height: 1, }}></div>
                                </td>
                            </tr> : <></>}
                        </>)}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
};
